/**
 * Returns `true` when Hub typography customization should be active.
 *
 * Gated by THREE things ANDed together:
 *   1. The product-level flag `advanced-theming-in-hub` (via HubContext —
 *      checked transitively through `useIsAdvancedThemingEnabled`).
 *   2. The platform-level Statsig gate `hub-advanced-theming` (the v2
 *      colour palette gate — checked transitively).
 *   3. The new platform-level Statsig gate `hub-typography`.
 *
 * The first two come from `useIsAdvancedThemingEnabled` — typography
 * is a sub-feature of advanced theming and never ships without it.
 *
 * Cross-host safe: returns `false` when HubContext is not mounted
 * (Confluence Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled`
 * returns false in that case.
 */
import { fg } from '@atlaskit/platform-feature-flags';

import { useIsAdvancedThemingEnabled } from '../use-is-advanced-theming-enabled';

export const useIsHubTypographyEnabled = (): boolean => {
	const isAdvancedThemingEnabled = useIsAdvancedThemingEnabled();
	return isAdvancedThemingEnabled && fg('hub-typography');
};
